const initialState = {
  fetching: false,
  fetched: false,
  fetchingStats: false,
  fetchedStats: false,
  saving: false,
  saved: false,
  selectedChoice: null,
  items: [],
  stats: [],
  error: null,
  errorStats: null,
  nbResult: 0
};
export const surveyReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_SURVEY_PENDING": {
      return { ...state, fetched: false, fetching: true };
    }
    case "SET_FETCHING": {
      return { ...state, fetching: action.payload };
    }
    case "FETCH_SURVEY_FULFILLED": {
      const { data, nbResult } = action.payload.data;

      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: data,
        nbResult: nbResult
      };
    }
    case "FETCH_SURVEY_REJECTED": {
      let error = action.payload;

      if (error && error.response && error.response.status) {
        switch (error.response.status) {
          case 404:
            error = {
              title: error.response.data.title,
              code: 404
            };
            break;
          default:
        }
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }
    case `SET_RESPONSE_PENDING`: {
      return { ...state, saved: false, saving: true };
    }
    case `SET_RESPONSE_FULFILLED`: {
      /*const { data } = action.payload.data;

      const object = state.items.find(item => item.id === data.id);
      if (!object) {
        const a = [data, ...state.items];
        const o2 = a.sort((a, b) => {
          return (
            new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
          );
        });
        return {
          ...state,
          saving: false,
          saved: true,
          items: o2,
          nbResult: state.nbResult + 1
        };
      }

      const newObj = { ...object, ...data };
      const newObjs = state.items.map(item => {
        return item.id === newObj.id ? newObj : item;
      });

      const o2 = newObjs.sort((a, b) => {
        return (
          new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
        );
      });

      return {
        ...state,
        items: o2
      };*/
      return state;
    }
    case `SET_RESPONSE_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
      }
      return {
        ...state,
        saving: false,
        saved: false,
        error
      };
    }
    case `FETCH_USER_RESPONSE_FULFILLED`: {
      const { data } = action.payload.data;
      return {
        ...state,
        selectedChoice:
          data &&
          data.answers &&
          data.answers[0].choices &&
          data.answers[0].choices[0].id
            ? data.answers[0].choices[0].id
            : null
      };
    }
    case "FETCH_SURVEY_STATS_PENDING": {
      return { ...state, fetchedStats: false, fetchingStats: true };
    }
    case "FETCH_SURVEY_STATS_FULFILLED": {
      const { data } = action.payload.data.data;

      return {
        ...state,
        fetchingStats: false,
        fetchedStats: true,
        errorStats: null,
        stats: data
      };
    }
    case "FETCH_SURVEY_STATS_REJECTED": {
      let error = action.payload;

      if (error && error.response && error.response.status) {
        switch (error.response.status) {
          case 404:
            error = {
              title: error.response.data.title,
              code: 404
            };
            break;
          default:
        }
      }
      return {
        ...state,
        fetchingStats: false,
        errorStats: error
      };
    }
    case "SET_SELECTED_CHOICE": {
      return { ...state, selectedChoice: action.choiceId };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/survey.js